import { Box, Stack, Typography } from '@mui/material';
import { minValue, required, useTranslate } from 'react-admin';

import { ShowSection } from '@sh4res/bo-common/components';
import { b2bCampaignAmountTypeInputChoices } from '@sh4res/bo-common/components/B2bCampaigns/choices';
import { B2bCampaignFormValues } from '@sh4res/bo-common/components/B2bCampaigns/types';
import { RadioButtonGroupInput } from '@sh4res/bo-common/components/RadioButtonGroupInput';
import { AmountInput } from '@sh4res/bo-common/fields';
import { useWatchObject } from '@sh4res/bo-common/hooks';
import { inputDisabledProps } from '@sh4res/bo-common/utils';

type Props = {
  isAgreementCommonForGroup?: boolean;
  isEditionDisabled: boolean;
  isAmountTypeEditionDisabled?: boolean;
};

const testId = 'BoExternalB2bCampaignCreateOperationAmountSection';

export const OperationAmountSection = (props: Props) => {
  const {
    isAgreementCommonForGroup,
    isEditionDisabled,
    isAmountTypeEditionDisabled = false,
  } = props;
  const translate = useTranslate();
  const { type, allocation_computed_by: allocationComputedBy } =
    useWatchObject<B2bCampaignFormValues>()(['type', 'allocation_computed_by']);

  return (
    <>
      {isAgreementCommonForGroup && (
        <ShowSection
          leftAligned
          label="resources.bo_common.b2b.campaigns.sections.general.group_operation_gross_amount"
          noCard={true}>
          <Typography>
            {translate(
              'resources.bo_common.b2b.campaigns.sections.general.group_operation_gross_amount_description',
            )}
          </Typography>

          <Stack direction="row" alignItems="center" gap={1} maxWidth="200px">
            <AmountInput
              data-testid={`${testId}_GroupOperationGrossAmountInput`}
              source="group_operation_gross_amount"
              isRequired
              min={1}
              validate={[required(), minValue(1)]}
              {...inputDisabledProps(isEditionDisabled)}
            />
            <Box>€</Box>
          </Stack>
        </ShowSection>
      )}
      <ShowSection
        leftAligned
        label="resources.bo_common.b2b.campaigns.sections.general.operation_amount"
        noCard={true}>
        <Typography>
          {translate(
            'resources.bo_common.b2b.campaigns.sections.general.operation_amount_description',
          )}
        </Typography>

        <Stack direction="row" alignItems="center" gap={1} maxWidth="200px">
          <AmountInput
            data-testid={`${testId}_AmountInput`}
            source="amount_input"
            isRequired
            min={1}
            validate={[required(), minValue(1)]}
            {...inputDisabledProps(isEditionDisabled)}
          />
          <Box>€</Box>
        </Stack>

        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {translate('resources.bo_common.b2b.campaigns.sections.general.amount_type_input')}
        </Typography>

        <RadioButtonGroupInput
          data-testid={`${testId}_AmountTypeInput`}
          source="amount_type_input"
          choices={b2bCampaignAmountTypeInputChoices}
          required
          disabled={
            isEditionDisabled ||
            isAmountTypeEditionDisabled ||
            allocationComputedBy === 'distributor' ||
            type === 'value_sharing_bonus' ||
            type === 'unused_vacation_days'
          }
        />
      </ShowSection>
    </>
  );
};
